<template>
    <div class="body" :class="{'bg-none': alert.show}">
        <template v-if="alert.show">
            <div class="d-flex vh-100 flex-column justify-content-center align-items-center">
                <div class="text-center text-warning display-1 mb-3">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="alert alert-warning" role="alert">
                    <span>{{ alert.message }}</span>
                </div>
            </div>
        </template>
        <template v-else>
            <template v-if="isLoading">
                <div class="d-flex vh-100 flex-column justify-content-center align-items-center">
                    <div class="spinner-border text-warning" role="status">
                        <span class="d-none">Loading...</span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="ticket-online pb-3">
                    <div class="row align-items-center position-sticky">
                        <div class="col-auto">
                            <a class="text-theme display-5" href="/">
                                <i class="fas fa-long-arrow-left"></i>    
                            </a>
                        </div>
                        <div class="col pl-0 pr-0">
                            <div class="logo">
                                <a class="mr-2" href="/">
                                    <img :src="logo" width="200" />
                                </a>
                            </div><!-- /logo -->    
                        </div>
                        <div class="col-auto">
                            <div class="dropdown show">
                                <a class="text-theme display-5" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                                    <h6 class="dropdown-header">Suporte</h6>
                                    <a class="dropdown-item" href="#service">
                                        <i class="fas fa-headset mr-2"></i>Atendimento
                                    </a>
                                    <h6 class="dropdown-header">Leia com atenção</h6>
                                    <a class="dropdown-item" href="/#rules">
                                        <i class="fas fa-book-open mr-2"></i>Regulamento
                                    </a>
                                    <a class="dropdown-item" href="/#betting-rules">
                                        <i class="fas fa-shield-alt mr-2"></i>Regras de aposta
                                    </a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" href="#share">
                                        <i class="fas fa-share mr-2"></i>Compartilhar aposta
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div><!-- /row -->
                    <template v-if="isValidadePaymentPix">

                    </template>
                    <template v-else>
                        <div class="row mb-3">
                            <div class="col">
                                <a class="btn btn-block btn-outline-success text-uppercase" href="javascript:void(0);" @click="pixToggle">
                                    <i class="far fa-file-invoice-dollar mr-2"></i>Gerar PiX para pagamento
                                </a>
                            </div>
                        </div>
                    </template>
                    <template v-if="isMobile() == 'desktop'">
                        <div class="row">
                            <div class="col text-white text-truncate">Código (Pré-Aposta)</div>
                            <div class="col text-white text-truncate text-right">Status pagamento</div>
                        </div><!-- /row -->
                        <div class="row">
                            <div class="col text-style text-theme text-truncate text-uppercase">{{ bet.codigo }}</div>
                            <div class="col text-style text-theme text-truncate text-right">Não pago</div>
                        </div><!-- /row -->
                        <div class="w-100 border-top border-dark mt-3 mb-3"></div>
                        <div class="row">
                            <div class="col text-white text-truncate">Valor</div>
                            <div class="col text-white text-truncate text-center">Possível prêmio</div>
                            <div class="col text-white text-truncate text-right">Apostador</div>
                        </div><!-- /row -->
                        <div class="row">
                            <div class="col text-style text-theme text-truncate">R$ {{ format_coin(bet.valor) }}</div>
                            <div class="col text-style text-theme text-truncate text-center">R$ {{ format_coin(bet.premio) }}</div>
                            <div class="col text-style text-theme text-truncate text-right">{{ bet.apostador }}</div>
                        </div><!-- /row -->
                    </template>
                    <template v-else>

                    </template>
                    <template v-if="pixShow">
                        <div class="card mt-3">
                            <div class="card-body">
                                <form @submit.prevent.stop="generatePay">
                                    <div class="form-group">
                                        <label for="name">Nome completo</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroupPrepend3">
                                                    <i class="fas fa-signature"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control" v-model="pixPayer.name" id="name" autocomplete="off" spellcheck="false" placeholder="Nome completo" required>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="cel">Telefone</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroupPrepend3">
                                                    <i class="fas fa-phone-alt"></i>
                                                </span>
                                            </div>
                                            <the-mask class="form-control" id="tel" v-model="pixPayer.cel" :mask="'(##) # ####-####'" autocomplete="off" spellcheck="false" aria-describedby="inputGroupPrepend3" required />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="cpf">CPF</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="inputGroupPrepend3">
                                                    <i class="fas fa-asterisk"></i>
                                                </span>
                                            </div>
                                            <the-mask class="form-control" id="cpf" v-model="pixPayer.document" :mask="'###.###.###-##'" autocomplete="off" spellcheck="false" required />
                                        </div>
                                    </div>
                                    <div class="form-row" :class="{'d-block': isMobile() == 'mobile'}">
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="pix_type">Tipo de chave pix </label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="inputGroupPrepend3">
                                                            <i class="fas fa-hashtag"></i>
                                                        </span>
                                                    </div>
                                                    <select class="form-control" id="pix_type" v-model="pixPayer.pix_type" required>
                                                        <option value="cpf_cnpj" :selected="pixPayer.pix_type == 'cpf_cnpj'">CPF</option>
                                                        <option value="email" :selected="pixPayer.pix_type == 'email'">E-mail</option>
                                                        <option value="celular" :selected="pixPayer.pix_type == 'celular'">Celular</option>
                                                        <option value="chave" :selected="pixPayer.pix_type == 'chave'">Chave aleatória</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="pix">Chave pix</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="inputGroupPrepend3">
                                                            <i class="fas fa-key"></i>
                                                        </span>
                                                    </div>
                                                    <template v-if="pixPayer.pix_type == 'cpf_cnpj'">
                                                        <the-mask class="form-control" id="pix" v-model="pixPayer.pix" :mask="['###.###.###-##']" autocomplete="off" spellcheck="false" required />
                                                    </template>
                                                    <template v-else-if="pixPayer.pix_type == 'celular'">
                                                        <the-mask class="form-control" id="pix" v-model="pixPayer.pix" :mask="'(##) # ####-####'" autocomplete="off" spellcheck="false" required />
                                                    </template>
                                                    <template v-else>
                                                        <input :type="pixPayer.pix_type == 'email' ? 'email' : 'text'" class="form-control" id="pix" v-model="pixPayer.pix" autocomplete="off" spellcheck="false" required />
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn btn-primary btn-block">
                                        <i class="fas fa-check-circle mr-2"></i>Gerar pagamento
                                    </button>
                                </form>
                            </div>
                        </div>
                    </template>
                    <div class="w-100 mt-3 mb-3">
                        <a class="btn btn-secondary btn-block text-uppercase" data-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Ver palpites ({{ total_hunches }})</a>
                        <div class="collapse multi-collapse mt-3" id="multiCollapseExample1" v-html="template"></div>
                    </div><!-- /w-100 -->
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import Vue from 'vue'

import {api} from '../../api'
import {TheMask} from 'vue-the-mask'
import moment from 'moment-timezone'
import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

Vue.use(SlimDialog)

export default {
    data() {
        return {
            bet: {
                ativa: 'sim',
                ao_vivo: 'nao',
                codigo: '',
                apostador: '',
                valor: '',
                premio: '',
                palpites: {}
            },
            alert: {
                show: false,
                message: ''
            },
            pixShow: false,
            pixPayer: {
                name: '',
                document: '',
                cel: '',
                pix: '',
                pix_type: '',
                email: ''
            },
            template: '',
            prebet_code: '',
            total_hunches: 0,
            isLoading: true,
            isValidadePaymentPix: false,
        }
    },
    components: {
        TheMask
    },
    methods: {
        searchPreBet(code) {

            const self = this;

            self.isLoading = true;
            self.alert.show = false;

            api.get(`prebet/${code}`, {
                headers: {
                    'X-RRR-UE': self.ue
                }
            }).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.bet = response.data.bet;
                    break;
                    case 'not_authorized':
                        self.$dialogs.confirm(`O sistema não autorizou a validação dessa aposta, tente novamente!`,{
                            title: 'Não autorizado!',
                            cancelLabel: 'Cancelar',
                            okLabel: 'Tentar novamente',
                            size: 'sm'
                        }).then(res => {
                            if (res.ok) {
                                window.location.reload();
                            }
                        });
                    break;
                    case 'nothing_found':
                        self.alert.show = true;
                        self.alert.message = 'A pré-aposta informada não foi encontrada!';
                    break;
                    default:
                        self.alert.show = true;
                        self.alert.message = response.data.message;
                    break;
                }
            }).catch((error) => {
                try {
                    self.alert.show = true;
                    self.alert.message = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.alert.show = true;
                    self.alert.message = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.isLoading = false;
            });
        },
        generatePay() {
            window.console.log(this.pixPayer)
        },
        convertHour(date) {
            return moment(date).tz('America/Recife').format('HH:mm');
        },
        convertDate(date) {
            return moment(date).tz('America/Recife').format('DD/MM/YY');
        },
        getTeamImage(team) {
            try {
                return `${this.image_server}/s/${this.remove_accents(team).toLowerCase().trim().replace(/[^a-z-0-9\s]/g, '').replace(/\s/g, '-')}.png`;
            } catch(e) {
                return 'shield.png';
            }
        },
        pixToggle() {
            this.pixShow = !this.pixShow;
        }
    },
    watch: {
        prebet_code(code) {
            if (/^[a-zA-Z0-9]+$/g.test(code) && code.toString().length >= 6 || code.toString().length <= 8) {
                this.searchPreBet(code);
            } else {
                this.message = 'O código da pre-aposta é inválido!';
            }
        },
        bet(values) {

            let anteior_value_team = 0;
            let hunches_order = this.orderByScheduleByBet(values.palpites);

            for (let key in hunches_order) {
                let hun = hunches_order[key];

                this.template += `
                    <div class="card mt-3">
                        ${anteior_value_team != hun.id ? `
                            <div class="card-header">
                            <div class="row">
                                <div class="col text-style text-theme text-truncate">
                                    <i class="fas fa-trophy-alt mr-2"></i>${hun.league}
                                </div>
                                <div class="col-auto text-style text-theme">${this.convertDate(hun.schedule)}</div>    
                            </div>
                        </div>
                        ` : ''}
                        <div class="card-body">
                            ${anteior_value_team != hun.id ? `
                                <div class="row align-items-center mb-3">
                                    ${this.isMobile() == 'desktop' ? `
                                        <div class="col text-truncate">
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                                <div>
                                                    <img class="align-middle object-fit" src="${this.getTeamImage(hun.team_home)}" onerror="this.src='/images/shield_default.png'" onload="imageCheck(this)" width="38" height="38" border="0">    
                                                </div>
                                                <div class="text-truncate text-center w-100">${hun.team_home}</div>    
                                            </div>
                                        </div>
                                        <div class="col-auto text-center">
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                                <div>
                                                    <img src="/images/versus_symbol.png" border="0" alt="X">
                                                </div>
                                                <div class="text-truncate text-center w-100">${this.convertHour(hun.schedule)}</div>    
                                            </div>
                                        </div>
                                        <div class="col text-truncate">
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                                <div>
                                                    <img class="align-middle object-fit" src="${this.getTeamImage(hun.team_away)}" onerror="this.src='/images/shield_default.png'" onload="imageCheck(this)" width="38" height="38" border="0">    
                                                </div>
                                                <div class="text-truncate text-center w-100">${hun.team_away}</div>    
                                            </div>    
                                        </div> 
                                    ` : `
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-8">
                                                    <div class="d-flex flex-row align-items-center justify-content-start">
                                                        <div>
                                                            <img class="shield" src="${this.getTeamImage(hun.team_home)}" onerror="this.src='/images/shield_default.png'" onload="imageCheck(this)" width="20" height="20" border="0">   
                                                        </div>
                                                        <div class="text-truncate ml-2 w-100">${hun.team_home}</div>  
                                                    </div>
                                                </div>
                                                <div class="col-4 text-right">Hora</div>
                                                <div class="w-100"></div>
                                                <div class="col-8">
                                                    <div class="d-flex flex-row align-items-center justify-content-start">
                                                        <div>
                                                            <img class="shield" src="${this.getTeamImage(hun.team_away)}" onerror="this.src='/images/shield_default.png'" onload="imageCheck(this)" width="20" height="20" border="0">   
                                                        </div>
                                                        <div class="text-truncate ml-2 w-100">${hun.team_away}</div>  
                                                    </div>
                                                </div>
                                                <div class="col-4 text-truncate text-right">
                                                    <div class="text-theme">${this.convertHour(hun.schedule)}</div>    
                                                </div>
                                            </div>    
                                        </div>
                                    `}   
                                </div><!-- /row -->
                                <hr />
                            ` : `
                                <div class="betbuilder-arrow">
                                    <i class="fas fa-arrows-v"></i>
                                </div>  
                            `}
                            <div class="row mb-3">
                                <div class="col">Modalidade</div>
                                <div class="col text-right">${hun.betbuilder ? 'Criar aposta': this.findModality(hun.sport)}</div>
                                <div class="w-100"></div>
                                <div class="col">Situação</div>
                                <div class="col text-right text-info">Aguardando</div>
                                <div class="w-100"></div>
                                <div class="col">Cotação</div>
                                <div class="col text-right">${'R$ ' + hun.odd}</div>
                                <div class="w-100"></div>
                                <div class="col">Ao vivo</div>
                                <div class="col text-right">${hun.live ? 'Sim' : 'Não'}</div>
                            </div><!-- /row -->
                            ${hun.message ? `
                                <div class="alert alert-warning text-center mb-0" role="alert">${hun.message}</div>
                            ` : `
                                <div class="alert alert-dark text-center mb-0" role="alert">${hun.market}</div>    
                            `}
                        </div>
                    </div>
                `;

                this.total_hunches += 1;
                anteior_value_team = hun.id;
            }
        }
    },
    created() {
        try {
            this.prebet_code = this.$route.params.code;
        } catch(e) {
            this.message = 'Ocorreu um erro na página, por favor, refaça sua pré-aposta novamente!';
        }
    }
}
</script>

<style scoped>
.body {
    width: 100%;
    min-height: 100vh;
    background-color: var(--background);
}
.body.bg-none {
    background-color: transparent;
}
.navbar {
    line-height: 46px;
}
.ticket-online {
    max-width: 500px;
    margin: 0 auto;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .ticket-online {
    max-width: 100%;
    margin: 0 1rem;
  }
}
</style>